/***********************************************************
Royal Hawaiian Services
Alexander Self
2/6/18
Mech harvest create: Handles the creation of new records
***********************************************************/
import React, { Component } from 'react';
import MechHarvestTable from './mechHarvest_table';

class MechanicalHarvestDisplay2 extends Component {
  render() {
    if (!this.props.harvest) return <div></div>;
    
    return (
      <div>
      {
        this.props.harvest && this.props.harvest.map((h) => {
          const { 
            containerType, 
            eid, 
            equipmentNo, 
            estLbsPerContainer, 
            notes 
          } = h;
          let emp = this.props.employees.find((e) => e.eid === eid)
          return (
            <div key={h.id ? h.id : h.guid} className="card-body">
              <div className="row">
                <div className="col s6 m3 l3 xl3 b-r">
                  <strong>Operator</strong>
                  <p>{ emp && `${emp.firstName[0]}. ${emp.lastName}` }</p>
                </div>
                <div className="col s6 m3 l3 xl3 b-r">
                  <strong>Equipment</strong>
                  <p>{ equipmentNo }</p>
                </div>
                <div className="col s6 m3 l3 xl3 b-r">
                  <strong>Container Type</strong>
                  <p>{ containerType }</p>
                </div>
                <div className="col s6 m3 l3 xl3">
                  <strong>Est Lbs/Container</strong>
                  <p>{ estLbsPerContainer }</p>
                </div>
              
                <div className="row">
                  <strong>Notes</strong>
                  <p>{ notes }</p>
                </div>
                <div>
                  <MechHarvestTable 
                    harvest={[h]} 
                    field={{}} 
                    totals={false} 
                  />
                </div>
                <br />
              </div>
            </div>
          )
        })
      }
      </div>
      
      
    )
  }
}

export default MechanicalHarvestDisplay2;




/* END */



// WEBPACK FOOTER //
// ./src/components/harvest/mechHarvest_display_2.jsx